"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportToPDF = void 0;
const pdfExporters_1 = require("./pdfExporters");
const exportToPDF = (data, t, type, extraData) => {
    switch (type) {
        case 'order':
            return (0, pdfExporters_1.exportOrderToPDF)(data, t);
        case 'invoice':
            return (0, pdfExporters_1.exportOrderToPDF)(data, t);
        case 'clubInvoice':
            return (0, pdfExporters_1.exportClubInvoiceToPDF)(data, t);
        case 'settlement':
            return (0, pdfExporters_1.exportSettlementToPDF)(data, t);
        case 'pdfInvoices':
            return (0, pdfExporters_1.exportPdfInvoicesToPDF)(data, t);
        case 'pdfBills':
            return (0, pdfExporters_1.exportPdfBillsToPDF)(data, extraData, t);
        default:
            throw new Error('Tipo de exportación no soportado');
    }
};
exports.exportToPDF = exportToPDF;
